<template>
    <div class="m-userinfo">

        <p class="info-txt">
            <span>欢迎，</span>
            <span class="player-name">{{ ($store.state.userinfo.nickName || uid_handler($store.state.userinfo.uid) )|e }}</span>
            <span class="area-name" v-if="$store.state.login && $store.state.userinfo.areaId">【{{ queryArea($store.state.userinfo.areaId) }}】</span>
            <span v-if="($store.state.login && !$store.state.userinfo.areaId) && $store.state.lock" class="bind" @click="$bind_modal()">【绑定大区】</span>

            <span v-if="$store.state.login && !KD.isApp() && $store.state.userinfo.uid" class="logout" @click="call_logout">【退出】</span>
            <span v-if="!$store.state.login || !$store.state.userinfo.uid" class="login" @click="call_login">【登录】</span>            
        </p>
       
    </div>
</template>

<script>
import KD from '@/assets/js/kd.js';
import mslogin from '@/assets/js/msLogin.js';

export default {
    data (){
        return {
            KD : KD,
        }
    },
    props : {
        info : {
            default : () => {}
        },
        login_flag : {
            default : 0,
        },
    },
    filters : {
        e(str) {return str || '仙术师'}
    },    
    methods : {
        queryArea(num) {
            var area = '暂无大区信息';

            if (num == 1) {
                area = '火烧赤壁';
            } else if (num == 2) {
                area = '草船借箭';
            } else if (num == 6) {
                area = '荆州之战';
            } else if (num == 7) {
                area = '青梅煮酒';
            } else if (num == 8) {
                area = '官渡之战';
            } else if (num == 9) {
                area = '桃园结义';
            } else if (num == 11) {
                area = '九伐中原';
            } else if (num == 12) {
                area = '逐鹿中原';
            } else if (num == 13) {
                area = '三分天下';
            } else if (num == 16) {
                area = '怀旧服';
            }else if (num == 17) {
                area = '铜雀台';
            } else if (num == 18) {
                area = '凤仪亭';
            }else if (num == 19) {
                area = '火凤燎原';
            }else if (num == 20) {
                area = '卧龙出渊';
            }else if (num == 21) {
                area = '长生殿';
            }else if (num == 22) {
                area = '逍遥津';
            }else if (num == 23) {
                area = '单刀赴会';
            }else if (num == 100 || num == 101) {
                area = '测试大区';
            }

            return area;
        },

        call_login(){
            mslogin.open();
        },

        call_logout(){
            var _this = this;
            localStorage.clear();
            setTimeout(function () { 
                //TODO   
                document.location = _this.$global.domain;
            }, 100);             
        },

        switch_area (){
            this.$close_book();
            this.$bind_modal();
        },
        uid_handler(uid){
            return uid ? uid.toString().slice(0,6) + '****' : '仙术师'    
        },        
    },
}
</script>

<style scoped>
.m-userinfo{
    position: absolute;
    top: -7px;
    left: 50%;
    width: 750px;
    height: 98px;
    line-height: 98px;
    margin: 0 auto;
    font-size: 24px;
    /* text-align: center; */
    color: #d7b876;
    background-image: url(~@/assets/images/bg-user.png);
    transform: translateX(-50%);
}

.m-userinfo p{
    padding-left: 45px;
}

.u-btn.logout,
.u-btn.login{
    color: #ffeb76;
}

.login{
    position: absolute;
    /* float: right; */
    display: inline-block;
    width: 117px;
    height: 37px;
    top: 29px;
    right: 26px;
    color: transparent;
    font-size: 0;
    background-image: url(~@/assets/images/btn-login.png);
    cursor: pointer;
}


.logout {
    position: absolute;
    display: inline-block;
    /* float: right; */
    width: 117px;
    height: 37px;
    top: 29px;
    right: 26px;
    color: transparent;
    font-size: 0;
    background-image: url(~@/assets/images/btn-logout.png);
    cursor: pointer;
}

.info-txt{
    display: flex;
}

.player-name{
    display: inline-block;
    max-width: 300px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;        
}
</style>


// WEBPACK FOOTER //
// src/components/userinfo.vue